module.exports = __webpack_public_path__ + "img/logo.de826ef1.png";